import { Navigate } from 'react-router-dom';

export default function BabysitterDashboard() {
  return <Navigate to="/dashboard/calendar" replace />;
}
